/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AgentSessionMeta = {
  /**
   * Speakeasy chat id for the captured session.
   */
  chatId: string;
  /**
   * The native harness session identifier this entry resolves, echoed from the request.
   */
  sessionId: string;
  /**
   * Generated (or manually set) chat title. Absent when no title has been generated yet.
   */
  title?: string | undefined;
  /**
   * Last activity recorded for the captured session.
   */
  updatedAt: Date;
};

/** @internal */
export const AgentSessionMeta$inboundSchema: z.ZodMiniType<
  AgentSessionMeta,
  unknown
> = z.pipe(
  z.object({
    chat_id: z.string(),
    session_id: z.string(),
    title: z.optional(z.string()),
    updated_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "chat_id": "chatId",
      "session_id": "sessionId",
      "updated_at": "updatedAt",
    });
  }),
);

export function agentSessionMetaFromJSON(
  jsonString: string,
): SafeParseResult<AgentSessionMeta, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AgentSessionMeta$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AgentSessionMeta' from JSON`,
  );
}
